import React, { Component, useState } from "react";
import { useContext } from "react";
import { BsFillHeartFill } from "react-icons/bs";
import Slider from "react-slick";
import axios from "axios";
import { CommonModules, DemoButton, KioskModule } from "./CommonModules";
import { QRCodePos } from "./POS";
import { TableOrderPos } from "./POS";

import {
  Accordion,
  Table,
  Carousel,
  Badge,
  Nav,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import CartContext from "./CartContext";
import {
  RetailPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  ErpRetail,
  LeadsManagementModule,
  CouponsManagementModule,
  ECommerceB2CModule,
  ECommerceB2cRestaurantModule,
  KdsModule,
  RecipeManagementModule,
} from "./CommonModules";

export class Kiosk extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <>
        {/* KIOSK-POS */}
        <div class="container-fluid py-3" id="kioskSection">
          <div class="container">
            <div class="row gx-5 mb-5">
              <div class="border-start border-5 border-primary ps-3 mb-3">
                <h6 class="text-primary text-uppercase">Product & Features</h6>
                <h2 class="display-6 text-uppercase mb-0">
                  <b>KIOSK POS Software</b>
                </h2>
              </div>
              <span className="text-muted" style={{ textAlign: "justify" }}>
                We offer KIOSK based custom solution for any Retail business.
                The Kiosk can be used as Digital catalog/Menu and Self-ordering
                POS. We provide Software solution and setup to onboard KIOSK
                based solution for any business. Call us to learn more!
              </span>
              <div className="col-lg-12 mb-lg-5 py-5">
                <video
                  controls
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  // className="rounded shadow"
                  aria-label="POS software demo video"
                >
                  <source
                    src={
                      this.context.GetEcSettingValueByName(
                        "StorageBlobImageUrl"
                      ) + "KioskVideo.mp4"
                    }
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
              <br></br>
              <div class="col-lg-6  border-dark CornersRoundedBig border ">
                <img
                  class="w-100 h-100 rounded "
                  src="img/kiosk.png"
                  style={{ objectFit: "contain" }}
                />
              </div>

              <div class="col-lg-6  ">
                <h4 class="text-body mb-2 my-2">
                  <h6 className="text-black ">
                    <Button
                      as={Link}
                      variant="warning"
                      className="w-100"
                      to="/Checkout"
                      onClick={() => {
                        if (this.context.userData.loginStatus !== "active") {
                          this.context.ShowUserLoginNew(true);
                        }
                        this.context.SetSelectedProduct(
                          this.context.prods.find(
                            (f) =>
                              f.productType ===
                              this.context.ProductType.KIOSK_ECommerce
                          )
                        );
                      }}
                    >
                      Try Free / Buy
                    </Button>
                    <DemoButton></DemoButton>
                    <h4> Benefits</h4>
                    <ul
                      className="text-muted"
                      style={{ lineHeight: "1.5em", marginBottom: "15px" }}
                    >
                      <li>User-friendly Kiosk Software</li>
                      <li>Save Labor Cost by 50%</li>
                      <li>Delight Customer and Envy Competitors</li>
                      <li>Improved Customer Satisfaction</li>
                      <li>Reduce POS Queue time by 50%</li>
                      <li>Increase Turnover</li>
                    </ul>
                    <h4> Features</h4>
                    <ul
                      className="text-muted"
                      style={{ lineHeight: "1.5em", marginBottom: "15px" }}
                    >
                      <li>✔ Free SSL and Custom domain</li>
                      <li>✔ Premium & Custom Themes</li>
                      <li>✔ OTP Authentication (SMS)</li>
                      <li>✔ UPI Integration</li>
                      <li>✔ Product Variants, Multi-Image, Video</li>
                      <li>✔ Paper/Paperless Invoice </li>
                      <li>✔ Multi-Store, Multi-Vendor, Multi-Currency</li>
                      <li>✔ Product Reviews, Ratings, and Comments</li>
                      <li>✔ Analytics, Reports, Customer Dashboard</li>
                    </ul>
                  </h6>
                </h4>
              </div>
            </div>
            {/* ERP Modules Section */}
            <DemoButton></DemoButton>
            <div class="border-start border-5 border-primary ps-3 mb-3">
              <h5 className="display-6 text-dark mb-4">
                Explore Integrated ERP Modules That Power Your Business
              </h5>
            </div>
            <Row className="g-3">
              {[
                KioskModule,
                InventoryModule,
                PurchasesModule,
                OrdersManagementModule,
                PackagingManagementModule,
                DeliveryManagementModule,
                CrmModule,
                CouponsManagementModule,
                HrmModule,
                AccountingModule,
                ReportsModule,
              ].map((Module, index) => (
                <Col md={6} lg={6} key={index}>
                  <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                    <Module />
                  </div>
                </Col>
              ))}
            </Row>
            <DemoButton></DemoButton>
          </div>
        </div>
      </>
    );
  }
}
